export enum LineOfBusinessId {
  COMMERCIAL = 1,
  MEDICARE = 2,
  MEDICAID = 3,
}
